import { Card } from "@/components/ui/card";

export const ContactMap = () => {
  console.log('Rendering ContactMap component');
  
  return (
    <Card className="overflow-hidden">
      <iframe
        title="Oklahoma City Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d207914.0656164981!2d-97.6663826!3d35.4729886!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87ad8a547ef8d281%3A0x33a21274d14f3a9d!2sOklahoma%20City%2C%20OK!5e0!3m2!1sen!2sus!4v1708745477947!5m2!1sen!2sus"
        width="100%"
        height="400"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </Card>
  );
};